import {AxiosInstance} from 'axios';

export interface FeedbackPayload {
    feedback_type: string;
    message: string;
    page_url?: string | null;
    browser_info?: string | null;
    openreplay_url?: string | null;
}

export interface FeedbackItem {
    id: number;
    feedback_type: string;
    message: string;
    page_url: string | null;
    browser_info: string | null;
    openreplay_url: string | null;
    created_at: string;
}

export function createFeedbackApi(client: AxiosInstance) {
    return {
        async submitFeedback(payload: FeedbackPayload): Promise<{ status: string }> {
            const response = await client.post('/api/feedback', payload);
            return response.data;
        },
        async listFeedback(): Promise<FeedbackItem[]> {
            const response = await client.get('/api/feedback');
            return response.data;
        },
    };
}
